module.exports = __webpack_public_path__ + "static/Mike_Moran_headshot_lores-775030b3015ae88e5d6964d0587be58a.png";